import React, { createContext, useContext, ReactNode } from 'react';
import { UserPreferences, AppSettings, CacheData } from '@/types/storage';
import { useLocalStorage } from '@/hooks/useStorage';
import buildInfo from '../../build-info.json';

interface StorageContextType {
  // Пользовательские настройки
  preferences: UserPreferences;
  setPreferences: (preferences: UserPreferences | ((prev: UserPreferences) => UserPreferences)) => void;
  
  // Настройки приложения
  settings: AppSettings;
  setSettings: (settings: AppSettings | ((prev: AppSettings) => AppSettings)) => void;
  
  // Кэш данных
  cache: CacheData;
  setCache: (key: string, data: any, ttl?: number) => void;
  getCache: (key: string) => any;
  clearCache: (key?: string) => void;
  
  // Утилиты
  clearAllData: () => void;
  exportData: () => string;
  importData: (data: string) => boolean;
  barndInfo: {
    name: string;
    address: string;
    phone: string;
    email: string;
    website: string;
    map: string;
    gps: string;
  }
  autoList: {
    name: string;
    startPrice: number | string;
    img: string;
    view: boolean;
  }[]
  singupServices: {
    name: string;
    type: string;
    view: boolean;
  }[]
  ptoName: string;
  apiUrl: string;
}

const StorageContext = createContext<StorageContextType | undefined>(undefined);

interface StorageProviderProps {
  children: ReactNode;
}
const apiUrl="https://api.pto-ykon.ru"
const barndInfo = {
  name: 'ООО "Авто Эксперт"',
  address: 'обл. Московская, р-н Ленинский, 21-й км Варшавского шоссе, зд.7.',
  phone: '+7 (926) 777-43-24',
  email: 'Auto-expert2025@mail.ru',
  website: 'https://autoexpert.ru',
  map: "https://yandex.ru/map-widget/v1/?ll=37.604123%2C55.565614&mode=routes&rtext=~55.565631%2C37.604125&rtt=auto&ruri=~ymapsbm1%3A%2F%2Fgeo%3Fdata%3DIgoNoGoWQhU1Q15C&z=19.29",
  gps: "55.565614,37.604120"
}

const autoList = 
  [
    {
        name: "Технический осмотр легкового автомобиля",
        startPrice: 1182,
        img: "Car",
        view: true
    },
    {
        name: "Технический осмотр автобуса полной массой до 5 тонн",
        startPrice: 2055,
        img: "/img/iblock/e13/e13616da4cac44f10652436e16314f86.jpg",
        view: false
    },
    {
        name: "Технический осмотр автобуса полной массой свыше 5 тонн",
        startPrice: 2483,
        img: "/img/iblock/c40/c40a20dde69fbd06fe10647d6b389c4a.jpg",
        view: false
    },
    {
        name: "Технический осмотр грузового автомобиля с полной массой до 3.5 тонн",
        startPrice: 1283,
        img: "/img/iblock/555/555efb391fc39babd2d310e8fabf5535.jpg",
        view: false
    },
    {
        name: "Технический осмотр грузового автомобиля с полной массой от\n" +
            "                      3.5 до 12 тонн",
        startPrice: 2398,
        img: "/img/iblock/056/0565a8723d5eebcf024be0fad0d667c7.png",
        view: false
    },
    {
        name: "Технический осмотр грузового автомобиля с полной массой свыше 12 тонн",
        startPrice: 2588,
        img: "/img/iblock/eaf/eaf1e547c60777cd46e3f7026375ded0.jpg",
        view: false
    },
    {
        name: "Технический осмотр прицепа с полной массой до 0.75 тонн",
        startPrice: 978,
        img: "/img/iblock/079/0793560e51af984f6315dad4261da30e.jpg",
        view: false
    },
    {
        name: "Технический осмотр прицепа с полной массой от 0.75 до 3.5 тонн",
        startPrice: 978,
        img: "/img/iblock/1ff/1fff46af51a53700003d3cfed8fa59ec.jpg",
        view: false
    },
    {
        name: "Технический осмотр прицепа с полной массой от 3.5 до 10\n" +
            "                      тонн",
        startPrice: 1672,
        img: "/img/iblock/cc6/cc62fac786d906df7d8bbd68af1e2d98.jpg",
        view: false
    },
    {
        name: "Технический осмотр прицепа с полной массой свыше 10 тонн",
        startPrice: 1672,
        img: "/img/iblock/b9a/b9a1405a294ad4fb06e711c7dc8e5775.jpg",
        view: false
    },
    {
        name: "Технический осмотр мототранспортные средств",
        startPrice: "",
        img: "Motorcycle",
        view: true
    },
    {
        name: "Технический осмотр среднетоннажных грузовиков",
        startPrice: 1283,
        img: "/img/iblock/photo_2020-12-25_19-30-33.jpg",
        view: false
    },
]

const singupServices = [
  {
      name: "M1 Легковой автомобиль",
      type: "M1",
      view: true
  },
  {
      name: "М2 Автобус массой до 5 т.",
      type: "М2",
      view: false
  },
  {
      name: "М3 Автобус массой более 5 т.",
      type: "М3",
      view: false
  },
  {
      name: "N1 Грузовой автомобиль максимальной массой до 3.5 т.",
      type: "N1",
      view: false
  },
  {
      name: "N2 Грузовые автомобили максимальной массой от 3.5 т. до 12 т.",
      type: "N2",
      view: false
  },
  {
      name: "N3 Грузовые автомобили максимальной массой более 12 т.",
      type: "N3",
      view: false
  },
  {
      name: "О1,О2 Прицеп максимальной массой до 3.5 т.",
      type: "О1,О2",
      view: false
  },
  {
      name: "О3,О4 Прицеп и полуприцеп максимальной массой свыше 3.5 т.",
      type: "О3,О4",
      view: false
  },
  {
      name: "L1 Мототранспортное средство",
      type: "L1",
      view: true
  }
]

const ptoName="avtoexpert"

const defaultPreferences: UserPreferences = {
  theme: 'light',
  language: 'ru',
  notifications: true,
  autoSave: true
};

const defaultSettings: AppSettings = {
  version: buildInfo.version,
  lastVisit: new Date().toISOString(),
  userAgent: typeof window !== 'undefined' ? navigator.userAgent : '',
  screenResolution: typeof window !== 'undefined' ? `${window.screen.width}x${window.screen.height}` : '0x0'
};

export const StorageProvider: React.FC<StorageProviderProps> = ({ children }) => {
  // Пользовательские настройки
  const { value: preferences, setValue: setPreferences } = useLocalStorage<UserPreferences>('userPreferences', defaultPreferences);

  // Настройки приложения
  const { value: settings, setValue: setSettings } = useLocalStorage<AppSettings>('appSettings', defaultSettings);

  // Кэш данных
  const { value: cache, setValue: setCacheValue } = useLocalStorage<CacheData>('appCache', {});

  // Методы для работы с кэшем
  const setCache = (key: string, data: any, ttl: number = 5 * 60 * 1000) => {
    setCacheValue(prev => ({
      ...prev,
      [key]: {
        data,
        timestamp: Date.now(),
        ttl
      }
    }));
  };

  const getCache = (key: string) => {
    const cached = cache[key];
    if (!cached) return null;
    
    const isExpired = Date.now() - cached.timestamp > cached.ttl;
    if (isExpired) {
      // Удаляем истекший кэш
      setCacheValue(prev => {
        const newCache = { ...prev };
        delete newCache[key];
        return newCache;
      });
      return null;
    }
    
    return cached.data;
  };

  const clearCache = (key?: string) => {
    if (key) {
      setCacheValue(prev => {
        const newCache = { ...prev };
        delete newCache[key];
        return newCache;
      });
    } else {
      setCacheValue({});
    }
  };

  // Очистка всех данных
  const clearAllData = () => {
    setPreferences({
      theme: 'light',
      language: 'ru',
      notifications: true,
      autoSave: true
    });
    setSettings({
      version: '0.1.10',
      lastVisit: new Date().toISOString(),
      userAgent: navigator.userAgent,
      screenResolution: `${window.screen.width}x${window.screen.height}`
    });
    setCacheValue({});
  };

  // Экспорт данных
  const exportData = () => {
    const data = {
      preferences,
      settings,
      cache,
      exportDate: new Date().toISOString()
    };
    return JSON.stringify(data, null, 2);
  };

  // Импорт данных
  const importData = (data: string) => {
    try {
      const parsed = JSON.parse(data);
      
      if (parsed.preferences) setPreferences(parsed.preferences);
      if (parsed.settings) setSettings(parsed.settings);
      if (parsed.cache) setCacheValue(parsed.cache);
      
      return true;
    } catch (error) {
      console.error('Error importing data:', error);
      return false;
    }
  };




  const value: StorageContextType = {
    preferences,
    setPreferences,
    settings,
    setSettings,
    cache,
    setCache,
    getCache,
    clearCache,
    clearAllData,
    exportData,
    importData,
    barndInfo,
    autoList,
    singupServices,
    ptoName,
    apiUrl
  };

  return (
    <StorageContext.Provider value={value}>
      {children}
    </StorageContext.Provider>
  );
};

export const useStorageContext = (): StorageContextType => {
  const context = useContext(StorageContext);
  if (context === undefined) {
    throw new Error('useStorageContext must be used within a StorageProvider');
  }
  return context;
};
